import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IUsuario,
  ICreateUsuario,
  IListado,
  IQueryParam,
  IUpdateUsuario,
  IPermiso,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class UsuariosService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<IUsuario>> {
    let params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/usuarios`, { params });
  }

  public crear(dato: ICreateUsuario): Observable<IUsuario> {
    return this.http.post(`${api}/usuarios`, dato);
  }

  public listarPorId(id: string): Observable<IUsuario> {
    return this.http.get(`${api}/usuarios/${id}`);
  }

  public editar(id: string, dato: IUpdateUsuario): Observable<IUsuario> {
    return this.http.put(`${api}/usuarios/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/usuarios/${id}`);
  }

  static parsePermisos(permisos: IPermiso[]) {
    const permisosParseados: string[] = [];
    for (const permiso of permisos) {
      permisosParseados.push(`<div
      style="margin: 0; padding-top: 1em;display: flex;
      justify-content: center;
      align-items: center;"
    >
      <!-- Nivel -->
      <p style="padding: 0.2em" matTooltip="Nivel">
        ${permiso.nivel}
      </p>

      <!-- Cliente -->
      ${
        permiso.nivel === 'Cliente'
          ? `<p
      style="padding: 0.2em; color: #eeafaf"
      matTooltip="Cliente"
    >
      ${permiso.cliente?.nombre} 
    </p>`
          : ''
      }

      <!-- Estableciemiento -->
      ${
        permiso.nivel === 'Establecimiento'
          ? `<p
      style="padding: 0.2em; color: #eeafaf"
      matTooltip="Estableciemiento"
    >
      ${permiso.establecimiento?.nombre || 'Sin Configurar'}
    </p>`
          : ''
      } 

      <!-- Rol -->
      <p style="padding: 0.2em; color: #afeeee" matTooltip="Rol">
        ${permiso.rol}
      </p>
    </div>`);
    }
    return permisosParseados.join('');
  }

  static parseActivo(activo: boolean) {
    if (activo) {
      return `<span class="material-icons" style="color: green">done</span>`;
    } else {
      return `<span class="material-icons" style="color: red">clear</span>`;
    }
  }
}
